import API from "../../core/apiConfig";
import type { PermissionQueryParams } from "./types";

type PermissionTreeNode = Record<string, unknown> & {
  _id?: string;
  id?: string;
  key?: string;
  code?: string;
  title?: string;
  name?: string;
  label?: string;
  value?: string;
  children?: PermissionTreeNode[];
  permissions?: PermissionTreeNode[];
};

const convertData = (
  data: PermissionTreeNode[],
  key?: string,
  title?: string,
): PermissionTreeNode[] =>
  data.map((item) => ({
    ...item,
    key: (key ? item[key] : item.key) as string | undefined,
    title: (title ? item[title] : item.title) as string | undefined,
    children: item.children?.length
      ? convertData(item.children)
      : item.permissions?.length
        ? convertData(item.permissions)
        : [],
  }));

export const getPermissionFeatures = async (params: PermissionQueryParams) => {
  const response = await API.get(
    "admin/permissions/features/actions",
    params,
  ).then((res) => res.data);

  if (response.success) {
    return convertData(response.data);
  }
};

export const getPermissionRegions = async (params: PermissionQueryParams) => {
  const response = await API.get("admin/permissions/regions", params).then(
    (res) => res.data,
  );

  if (response.success) {
    return convertData(response.data, "code", "name");
  }
};

export const getPermissionDirections = async (
  params: PermissionQueryParams,
) => {
  const response = await API.get(
    "/admin/permissions/directions",
    params,
  ).then((res) => res.data);

  if (response.success) {
    return convertData(response.data, "code", "name");
  }
};
